"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertKeysToCamelCase = exports.convertKeysToSnakeCase = exports.omitEmpties = exports.omitProperty = void 0;
const tslib_1 = require("tslib");
const common_1 = require("./common");
const isArray_1 = tslib_1.__importDefault(require("lodash/isArray"));
const isString_1 = tslib_1.__importDefault(require("lodash/isString"));
const snakeCase_1 = tslib_1.__importDefault(require("lodash/snakeCase"));
const camelCase_1 = tslib_1.__importDefault(require("lodash/camelCase"));
const isPlainObject_1 = tslib_1.__importDefault(require("lodash/isPlainObject"));
const omitProperty = (object, ...properties) => {
    const traverse = (object, path = '') => {
        return Object.entries(object).reduce((data, [key, value]) => {
            const currentPath = !path ? key : `${path}.${key}`;
            if (properties.includes(key) || properties.includes(currentPath)) {
                return data;
            }
            else if ((0, isPlainObject_1.default)(value)) {
                data[key] = traverse(value, currentPath);
            }
            else
                data[key] = value;
            return data;
        }, {});
    };
    return traverse(object);
};
exports.omitProperty = omitProperty;
const omitEmpties = (object, config = {}) => {
    // destructing config with default
    const { ignore = [], removeEmptyObject = true } = config;
    // Function to traverse through deep object
    const traverse = (object, path = '') => {
        return Object.entries(object).reduce((data, [key, value]) => {
            // Concat path with parent path
            const currentPath = !path ? key : `${path}.${key}`;
            // If value is empty returning
            if ((0, common_1.isEmpty)(value) && !ignore.includes(currentPath))
                return data;
            // Keeping the value
            if (!(0, isPlainObject_1.default)(value))
                data[key] = value;
            // if object then traversing again
            else
                data[key] = traverse(value, currentPath);
            // returning the final object
            return data;
        }, {});
    };
    if (!removeEmptyObject)
        return traverse(object);
    return traverse(traverse(object));
};
exports.omitEmpties = omitEmpties;
const convertKeysToSnakeCase = (data) => {
    const nested = (b) => {
        return (0, isArray_1.default)(b) || (0, isPlainObject_1.default)(b) ? (0, exports.convertKeysToSnakeCase)(b) : b;
    };
    if ((0, isString_1.default)(data))
        return (0, snakeCase_1.default)(data);
    if ((0, isArray_1.default)(data))
        return data.map(nested);
    if ((0, isPlainObject_1.default)(data))
        return Object.entries(data).reduce((converted, [key, value]) => {
            key = (0, exports.convertKeysToSnakeCase)(key);
            return Object.assign(Object.assign({}, converted), { [key]: nested(value) });
        }, {});
    return data;
};
exports.convertKeysToSnakeCase = convertKeysToSnakeCase;
const convertKeysToCamelCase = (data) => {
    const nested = (b) => {
        return (0, isArray_1.default)(b) || (0, isPlainObject_1.default)(b)
            ? (0, exports.convertKeysToCamelCase)(b)
            : (0, common_1.secureDataType)(b);
    };
    if ((0, isString_1.default)(data))
        return (0, camelCase_1.default)(data);
    if ((0, isArray_1.default)(data))
        return data.map(nested);
    if ((0, isPlainObject_1.default)(data))
        return Object.entries(data).reduce((converted, [key, value]) => {
            key = (0, exports.convertKeysToCamelCase)(key);
            return Object.assign(Object.assign({}, converted), { [key]: nested(value) });
        }, {});
    return data;
};
exports.convertKeysToCamelCase = convertKeysToCamelCase;
